import { http, HttpResponse } from 'msw';
import { env } from '@repo/env';
import { successCancel } from './mocks/loan-cancel.mock';
var apiUrl = env.VITE_API_URL;
export var loanCancelHandler = [
    http.patch("".concat(apiUrl, "/loan/cancel"), function () {
        return HttpResponse.json(successCancel);
    }),
];
